export const PREFERRED_BU_COMMON_STATUSES = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  DELETED: "DELETED",
  DECLINED: "DECLINED",
};
